import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface MemoryGameResultItemProps {
    answer: AnswerResult,
}

function MemoryGameResultItem(props: MemoryGameResultItemProps): JSX.Element {
    const start = new Date(Date.parse(props.answer.start_time));
    const end = new Date(Date.parse(props.answer.end_time));
    const answerDuration = getDurationInSeconds(end, start);
    const answer: string[] = props.answer.value.split(";");
    const pairs = answer[0];
    const clickCount = answer[1];
    const bestPossible = parseInt(pairs) * 2;

    const answerTime = <span className="pb-1" key={"answerTime-" + props.answer.id}>{answerDuration + ' s'}</span>;
    const answerPairs = <span className="pb-1" key={"pairs-" + props.answer.id}>{pairs}</span>;
    const answerClickCount = <span className="pb-1" key={"clickCount-" + props.answer.id}>{clickCount + "/" + bestPossible}</span>;
    const gameName = <span className="pb-1" key={"gameName-" + props.answer.id}>{props.answer.item.name}</span>

    let level = <></>;


    if (Number(pairs) >= 12) {
        level = (
            <div>
                <span className="text-xl text-red-500 ri-game-fill"></span>
                <span className="text-xl text-red-500 ri-game-fill"></span>
                <span className="text-xl text-red-500 ri-game-fill"></span>
            </div>);

    } else if (Number(pairs) >= 6) {
        level = (
            <div>
                <span className="text-xl text-yellow-500 ri-game-fill"></span>
                <span className="text-xl text-yellow-500 ri-game-fill"></span>
            </div>);
    } else {
        level = (
            <div>
                <span className="text-xl text-green-500 ri-game-fill"></span>
            </div>);
    }

    return (
        <div className="grid grid-cols-6">
            <div className="col-span-2">{gameName}</div>
            <div>{level}</div>
            <div>{answerPairs}</div>
            <div className="ml-5">{answerClickCount}</div>
            <div className="ml-10">{answerTime}</div>
        </div>
    );
}

export default MemoryGameResultItem;
